import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
//import Button from '../button/index'
import { HeaderWrapper, LogosWrapper, MenuWrapper, HamburguerMenuButton } from './style'
import LogoSeguroSrc from '../../images/logos/logo-dark.png'
import globals from '../globals'

const Hamburguer = props => {
  return (
    <div className="hamburger-box">
      <div className="hamburger-inner"></div>
    </div>
  )
}

const Header = ({ siteTitle, withBackground, paintHeader }) => {

  const [ isMenuOpen, setMenuOpen ] = useState( false )

  const handleAnchor = event => {
    event.preventDefault()
    const id = event.currentTarget.getAttribute('href').replace('#', '')
    const target = document.getElementById( id )

    if(target){
      target.scrollIntoView({behavior: 'smooth'})
    }      
    if(isMenuOpen){
      setMenuOpen(false) 
    }
  }

  return (
    <HeaderWrapper withBackground={withBackground} paintHeader={paintHeader}>
      <LogosWrapper>
        <li>
          <Link to="/">
            <img src={LogoSeguroSrc} alt="Seguro Residencial CredPago" />
          </Link>
        </li>
      </LogosWrapper>
      <MenuWrapper withBackground={withBackground} isMenuOpen={isMenuOpen}>
        <HamburguerMenuButton size="large" isActive={isMenuOpen} onClick={() => setMenuOpen(!isMenuOpen)} className="menu-toggle" type="ghost">
          <Hamburguer />
        </HamburguerMenuButton>
        <ul>
          <li className="dot"><a onClick={handleAnchor} href="#faq">FAQ | Dúvidas Frequentes</a></li>
          <li className="dot"><a href={globals.LINK_CADASTRO}>Cadastrar Empresa</a></li>
          {/* <li className="dot"><Link to="/contato">Contato</Link></li>           */}
          <li className="dot"><a onClick={handleAnchor} href="#contato">Contato</a></li>
        </ul>
      </MenuWrapper>
    </HeaderWrapper>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  withBackground: PropTypes.bool
}

Header.defaultProps = {
  siteTitle: ``,
  withBackground: false
}

export default Header
